import { render, staticRenderFns } from "./importComponent.vue?vue&type=template&id=61ec0472&scoped=true"
import script from "./importComponent.vue?vue&type=script&lang=js"
export * from "./importComponent.vue?vue&type=script&lang=js"
import style0 from "./importComponent.vue?vue&type=style&index=0&id=61ec0472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec0472",
  null
  
)

export default component.exports